"use strict"

import angular from "angular"

angular.module("uCountitUiApp").service("JusoAddressSrv", function ($window) {
  return {
    openAddressPopup: function (addressKey, callback) {
      const baseUrl = "https://business.juso.go.kr/addrlink/addrLinkUrl.do"
      const returnUrl = new URL($window.location.href)
      returnUrl.pathname = "/api/address/return"
      const url =
        `${baseUrl}?confmKey=${encodeURIComponent(addressKey)}` +
        `&returnUrl=${encodeURIComponent(returnUrl.toString())}`

      const pop = $window.open(url, "jusoPop", "width=570,height=420,scrollbars=yes,resizable=yes")
      if (!pop) {
        return
      }

      // NOTE: Juso API 사용 가능 변수 목록 - https://business.juso.go.kr/addrlink/openApi/popupApi.do
      $window.jusoCallback = function (data) {
        if (callback && typeof callback === "function") {
          callback({
            address: data.roadAddrPart1,
            roadAddrPart1: data.roadAddrPart1,
            addrDetail: data.addrDetail,
            ...data,
          })
        }
        if (pop && !pop.closed) {
          pop.close()
        }
      }
    },
  }
})
